import Head from "next/head";

import Link from "next/link";
import Layout from "../components/layout";
import { getPrivacyPage } from "../lib/api";
const Privacy = ({ privacyPage }) => {
  const openCookiePreferences = () => {
    if (window?.cookieconsent) {
      window.cookieconsent.openPreferencesCenter();
    }
  };
  return (
    <Layout noFooter>
      <Head>
        <title>{privacyPage.title} | Art in the Age of Metaverse</title>
      </Head>

      <div className="privacy-wrapper">
        <div className="privacy">
          <Link href="/" className="back-button">
            Back
          </Link>
          <h1>{privacyPage.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: privacyPage.content }} />
          <button
            className="cookie-button"
            onClick={openCookiePreferences}
            id="open_preferences_center"
          >
            Update cookies preferences
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default Privacy;

export const getStaticProps = async () => {
  console.log("get static props");
  const privacyPage = await getPrivacyPage();
  return {
    props: {
      privacyPage,
    },
  };
};
